/* eslint-disable react/jsx-no-bind */
import React, { useContext, useEffect, useState } from 'react';
import * as R from 'ramda';

import { monitorForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

import { CARD_SIZE_LG } from './constants';
import DashboardColumn from './dashboard-column';
import DashboardContext from './dashboard-context';
import { getColumnsData } from './utils';

import './dashboard.scss';

const DashboardGrid = () => {
  const {
    setAllCards,
    allCards,
    lgColumn,
    smColumn,
    updateLayout
  } = useContext(DashboardContext);

  const [isDraggingLg, setIsDraggingLg] = useState(false);
  const [isDraggingSm, setIsDraggingSm] = useState(false);

  // Monitor for drag events
  useEffect(() => {
    return monitorForElements({
      canMonitor: ({ source }) => source.data.type === 'dashboard-card',
      onDragStart: ({ source }) => {
        if (source.data.columnSize === CARD_SIZE_LG) {
          setIsDraggingLg(true);
        } else {
          setIsDraggingSm(true);
        }
      },
      onDrop: ({ source, location }) => {
        setIsDraggingLg(false);
        setIsDraggingSm(false);

        const destination = location.current.dropTargets[0];
        if (!destination) {
          return;
        }

        const sourceIndex = source.data.index;
        const col = source.data.columnSize;
        const destinationIndex = destination.data.index;
        const edge = extractClosestEdge(destination.data);

        // Calculate the new index
        let newIndex = destinationIndex;
        if (edge === 'bottom') {
          newIndex = destinationIndex + 1;
        }

        // Adjust if moving down
        if (sourceIndex < newIndex) {
          newIndex -= 1;
        }

        // Don't do anything if dropped in the same position
        if (sourceIndex === newIndex) {
          return;
        }

        const updatedCards = R.move(
          sourceIndex,
          newIndex,
          col === CARD_SIZE_LG ? lgColumn : smColumn
        ).map((card, idx) => ({ ...card, order: idx }));

        const newAllCards = allCards.map(card => {
          return card.size !== col || card.order === -1
            ? card
            : {
              ...updatedCards.find(updatedCard => updatedCard.id === card.id)
            };
        });

        const updatedColumns = col === CARD_SIZE_LG
          ? getColumnsData(updatedCards, smColumn)
          : getColumnsData(lgColumn, updatedCards);

        setAllCards(newAllCards);
        updateLayout(updatedColumns);
      }
    });
  }, [allCards, lgColumn, setAllCards, smColumn, updateLayout]);

  return (
    <div styleName="grid-container">
      {!R.isEmpty(lgColumn) && (
        <DashboardColumn cards={lgColumn} isDragging={isDraggingLg} size="large" />
      )}
      <DashboardColumn cards={smColumn} isDragging={isDraggingSm} size="small" />
    </div>
  );
};

export default DashboardGrid;
